<template>
  <div v-if="demandeIntervention">
    <div class="mgt-20px">
      <info-generale-intervention
        @goToUpdatePatrimoine="goToUpdatePatrimoine"
        :demandeIntervention="demandeIntervention"
        :is-update="isUpdate">
      </info-generale-intervention>
    </div>
    <div class="columns is-multiline mgt-20px">
      <div class="column is-12">
        <div class="card contactEdition">
          <div class="header-card">
            <p>
              {{ $t('editionIntervention.infoGenerale.sujetDemande') }}
            </p>
          </div>
          <div class="card-content">
            <b-field :label="$t('editionIntervention.infoGenerale.sujetDemande')"
                      class="obligatoire">
                <b-input type="textarea" v-model="demandeIntervention.actionLogistique">
                </b-input>
              </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline mgt-20px">
      <div class="column is-12">
        <div class="card contactEdition">
          <div class="header-card">
            <p>
              {{ $t('editionIntervention.infoGenerale.adresse') }}
            </p>
          </div>
          <div class="card-content">
            <app-adresse
                  :adresse="demandeIntervention.adresse"
                  :tableName="PRODUIT"
                  :afficherIntitule="false"
                  :displayGMap="true"
                  :affichageVertical="false"
            >
            </app-adresse>
          </div>
        </div>
      </div>
    </div>
    <input-text-area-card
      :title="$t('editionIntervention.infoGenerale.description')"
      :label="$t('editionIntervention.infoGenerale.description')"
      v-model="demandeIntervention.description"/>
    <piece-jointe :checkPermissions="true" class="mgt-20px"/>
  </div>
</template>

<script>

import infoGeneraleIntervention from '@/components/logistique/intervention/addEdit/infoGeneraleIntervention';
import { createNamespacedHelpers } from 'vuex';
import pieceJointe from '@/components/baux/contrat/componentEdition/pieceJointe';
import Adresse from '@/components/general/adresse';
import { PRODUIT } from '@/configuration/ville/villeConf';
import inputTextAreaCard from '@/components/general/inputTextAreaCard';

const Permissions = createNamespacedHelpers('permissions');
const Intervention = createNamespacedHelpers('intervention');

export default {
  name: 'demande_edition_informations',
  props: {
    demandeIntervention: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      PRODUIT,
      isUpdate: false,
    };
  },
  components: {
    infoGeneraleIntervention,
    pieceJointe,
    appAdresse: Adresse,
    inputTextAreaCard,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
  methods: {
    ...Intervention.mapActions({
      setInterventionCourant: 'setInterventionCourant',
    }),
    goToUpdatePatrimoine() {
      this.setInterventionCourant(this.demandeIntervention);
      this.$router.push({ name: 'm.logistique.demande_intervention-addPatrimoine' });
    },
  },
};
</script>-
